import { useState } from "react";

import fallbackImageSrc from "@/assets/logos/prequel.svg";
import { env } from "@/env";

type BrandedLogoProps = {
  orgID?: string;
};

const BrandedLogo = ({ orgID }: BrandedLogoProps) => {
  const defaultImageSrc = import.meta.env.VITE_APP_DEFAULT_LOGO ?? fallbackImageSrc;

  // Set the initial state of the image
  const [imageSrc, setImageSrc] = useState<string>(
    orgID && env.VITE_APP_ASSET_BUCKET
      ? `https://storage.googleapis.com/${env.VITE_APP_ASSET_BUCKET}/${orgID}.svg`
      : defaultImageSrc,
  );

  // If there's an issue loading the image, defer to a fallback
  const onImageLoadError = () => {
    setImageSrc(fallbackImageSrc);
  };

  return <img className="h-10 w-auto" src={imageSrc} alt="" onError={onImageLoadError} />;
};

export default BrandedLogo;
